// import React, { useState } from "react";
// import { HashRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
// import BookingPage from "./Components/BookingPage";
// import BookingTable from "./BookingTable";

// function AppContent() {
//   const location = useLocation();

//   // Load admin route immediately from localStorage (no useEffect delay)
//   const storedRoute = localStorage.getItem("adminRoute");
//   const [adminRoute, setAdminRoute] = useState(storedRoute);

//   const handleDynamicRoutes = (data) => {
//     setAdminRoute(data);
//     localStorage.setItem("adminRoute", data);
//   };

//   // ✅ Handle direct refresh: if user visits /admin-xxxxxx and it matches stored route
//   if (adminRoute && location.pathname === `/${adminRoute}`) {
//     return (
//       <Routes>
//         <Route path={`/${adminRoute}`} element={<BookingTable />} />
//         <Route path="*" element={<Navigate to={`/${adminRoute}`} replace />} />
//       </Routes>
//     );
//   }

//   return (
//     <Routes>
//       <Route path="/" element={<BookingPage handleDynamicRoutes={handleDynamicRoutes} />} />
//       {adminRoute && (
//         <Route path={`/${adminRoute}`} element={<BookingTable />} />
//       )}
//       {/* Redirect unknown routes */}
//       <Route path="*" element={<Navigate to="/" replace />} />
//     </Routes>
//   );
// }

// export default function App() {
//   return (
//     <Router>
//       <AppContent />
//     </Router>
//   );
// }
import React, { useState, useEffect } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import BookingPage from "./Components/BookingPage";
import BookingTable from "./BookingTable";

const ADMIN_PATH = "Admin_Hotel"; // ← you can change this value

function AppContent() {
  const location = useLocation();

  // Try to load from localStorage only once
  const [isAdminUnlocked, setIsAdminUnlocked] = useState(() => {
    return "true";
  });

  const unlockAdmin = () => {
    setIsAdminUnlocked(true);
    localStorage.setItem("adminUnlocked", "true");
  };

  // Optional: clear admin access (for logout / testing)
  const lockAdmin = () => {
    setIsAdminUnlocked(false);
    localStorage.removeItem("adminUnlocked");
  };

  // If user directly enters /Admin_Hotel but hasn't unlocked → redirect
  if (location.pathname === `/${ADMIN_PATH}` && !isAdminUnlocked) {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      {/* Main customer page */}
      <Route
        path="/"
        element={<BookingPage onUnlockAdmin={unlockAdmin} />}
      />

      {/* Protected admin route */}
      {isAdminUnlocked && (
        <Route
          path={`/${ADMIN_PATH}`}
          element={<BookingTable onLockAdmin={lockAdmin} />} // optional: pass logout
        />
      )}

      {/* Catch-all - always redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}